import {useAppDispatch, useAppSelector} from '../hooks'
import {selectPopupOpen, setPopupOpen} from '../slices/percentagePopupSlice'

// COMPLEX HOOK - For backward compatibility and convenience
// Use when: Migrating from Context, need all percentage popup functionality together
export const usePercentagePopup = () => {
  const dispatch = useAppDispatch()
  const popupOpen = useAppSelector(selectPopupOpen)

  return {
    popupOpen,
    setPopupOpen: (value) => dispatch(setPopupOpen(value))
  }
}

// SIMPLE SELECTOR HOOK - For targeted access
// Use when: Only need specific values, performance-critical components
export const usePopupOpen = () => useAppSelector(selectPopupOpen)
